/**
 * Dirty-tracking suppression flag.
 *
 * Scene load operations create new Map/Set references that the store
 * subscriber would otherwise interpret as content changes.  Callers
 * wrap their `setState` calls with `suppressDirtyTracking(true/false)`
 * to prevent the subscriber from marking the scene dirty.
 *
 * Extracted into its own module to avoid circular imports between
 * store.ts and storeSceneFileOps.ts.
 */

let _suppress = false;

/** Temporarily suppress dirty-tracking while applying a large state patch (scene load). */
export function suppressDirtyTracking(suppress: boolean): void {
  _suppress = suppress;
}

/** Check whether dirty-tracking is currently suppressed. */
export function isDirtyTrackingSuppressed(): boolean {
  return _suppress;
}
